/**
 * 로그인/재설정 화면의 개인·기업 탭 상태.
 *
 * 탭을 URL 쿼리로도 지정할 수 있게 둔 이유: 기업 고객에게 `?type=business` 전용
 * 링크를 안내해야 하는데, 라우트를 쪼개면 복귀 경로·가드 연동 로직이 두 벌이 된다.
 */
export type LoginTab = 'personal' | 'business';

export const LOGIN_TAB_PARAM = 'type';

const ORG_SLUG_STORAGE_KEY = 'howcost.login.orgSlug';

/**
 * 회사코드만 기억한다. 아이디·비밀번호는 저장하지 않는다 — 사내 공용 PC 에서
 * 두 번째 로그인부터 아이디만 치게 하려는 편의이고, 그 이상은 계정 노출이다.
 * 스토리지 접근이 막힌 환경(사생활 보호 모드 등)에서도 화면은 그대로 떠야 한다.
 */
export function readRememberedOrgSlug(): string {
  try {
    return localStorage.getItem(ORG_SLUG_STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}

export function rememberOrgSlug(slug: string): void {
  try {
    const value = slug.trim().toLowerCase();
    if (value) localStorage.setItem(ORG_SLUG_STORAGE_KEY, value);
  } catch {
    // 저장 실패는 다음 로그인에 회사코드를 한 번 더 치는 것뿐이라 무시한다.
  }
}
